import { render, staticRenderFns } from "./UserDemoSetForm.vue?vue&type=template&id=a10072c2"
import script from "./UserDemoSetForm.vue?vue&type=script&lang=js"
export * from "./UserDemoSetForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports